import React, {ReactNode} from 'react';
import styled from 'styled-components';

interface ArticleProps {
  img?: React.ReactNode;
  text: ReactNode;
  direction?: 'left' | 'right';
  maxWidthImage?: string | any;
}

const SCArticle = styled.div`
  overflow: hidden;
  margin: 2rem 0;
  /* border: 1px solid black; */
  .textBlockImage {
    max-width: 350px;
    float: left;
    margin: 0 auto 1rem auto;
  }
  .textBlockContent {
    text-align: center;
  }
  @media screen and (min-width: 800px) {
    .textBlockContent {
      text-align: initial;
      /* min-height: 340px; */
      padding: 0 0.5rem;
    }
    .textBlockImage {
      margin-right: 1.5rem;
      margin-bottom: 1rem;
      max-width: ${(props: ArticleProps) => props.maxWidthImage || '400px'};
    }
  }
`;

export function ArticleBlock(props: ArticleProps) {
  return (
    <SCArticle maxWidthImage={props.maxWidthImage} text>
      <div
        className="textBlockImage"
        style={{
          display: props.img ? 'initial' : 'none',
          float: props.direction || 'left',
          marginLeft: props.direction ? '1rem' : 'initial',
          // maxWidth: props.maxWidthImage ? props.maxWidthImage : '500px',
        }}
      >
        {props.img}
      </div>
      <div className="textBlockContent">{props.text}</div>
    </SCArticle>
  );
}
